<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.cardId') }}</div>
                <input v-model="searchParams.cardNumber" type="text" />
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ 'Khoảng thời gian sử dụng' }}</div>
                <CalendarRange v-model="searchParams.useDate" mode="date" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.guestCardUsingReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="note-container">
            <ul>
              <li>ID thẻ: ID của thẻ phòng được cấp cho khách</li>
              <li>Recode: Mã đặt phòng của phòng</li>
              <li>Số phòng chi tiết- hiển thị số phòng</li>
              <li>Ngày Checkin: Ngày khách check-in.</li>
              <li>Ngày Checkout: ngày khách dự kiến/ đã Checkout</li>
              <li>
                Thời gian sử dụng: thời gian khách dùng thẻ để mở/ đóng cửa
                phòng. Format DD/MM/YYYY HH:MM:SS
              </li>
              <li>Người tạo thẻ: Tên nhân viên tạo thẻ cho đặt phòng</li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import InfoBtn from './components/InfoBtn.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'

import {
  getLockRecordUseReport,
  getLockRecordUseReportExcel
} from '@/api/report_service/datntReport'
import { downloadFile } from '@/utils/file-handler'

export default {
  components: {
    DasButton,
    InfoBtn,
    CalendarRange
  },
  data() {
    return {
      noteDialogVisible: false,
      searchParams: {
        useType: 1,
        cardNumber: null,
        useDate: {
          start: null,
          end: null
        }
      },
      defaultSearchParams: {
        useType: 1,
        cardNumber: null,
        useDate: {
          start: null,
          end: null
        }
      },
      columns: [
        {
          headerName: this.$t('grid.column.cardId'),
          field: 'keyboard_pwd',
          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.recode'),
          field: 'recode',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.detailRoomNum'),
          field: 'room_num',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.checkinDate'),
          field: 'check_in_date',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 180
        },
        {
          headerName: this.$t('grid.column.checkoutDate'),
          field: 'check_out_date',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 180
        },
        {
          headerName: this.$t('grid.column.usedTime'),
          field: 'unlock_date',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 180
        },
        {
          headerName: this.$t('grid.column.cardCreatedBy'),
          field: 'create_user_name',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 200
        }
      ],
      rows: []
    }
  },

  mounted() {
    this.fnGetLockRecordUseReport()
  },
  methods: {
    onSearch() {
      this.fnGetLockRecordUseReport()
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetLockRecordUseReport()
    },
    onClickDropdownItem(cmd) {
      // this.$message('click on item ' + cmd)
      if (cmd === 'excel') {
        this.fnDownloadExcel()
      }
    },

    async fnGetLockRecordUseReport() {
      try {
        const query = {
          ...this.searchParams,
          dateFrom: this.searchParams.useDate.start,
          dateTo: this.searchParams.useDate.end
        }
        const res = await getLockRecordUseReport(query)
        this.rows = res.data
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },

    async fnDownloadExcel() {
      const query = {
        ...this.searchParams,
        dateFrom: this.searchParams.useDate.start,
        dateTo: this.searchParams.useDate.end
      }
      await getLockRecordUseReportExcel(query)
        .then(res => {
          downloadFile(res, 'bao_cao_su_dung_the_cua_khach.xlsx')
        })
        .catch(error => {
          const msg = error.response.data
          this.$message({
            message: this.$t(msg),
            type: 'error'
          })
        })
    }
  }
}
</script>

<style></style>
